import React from 'react'
import '../../CSS/global.css'

const ReusableButton = (props) => {
  return (
    <button className={props.className} disabled={props.disabled} type={props.type} onClick={props.onClick} onChange={props.onChange} style={props.style}>{props.buttonText}</button>
  )
}

export default ReusableButton;